import axios from 'axios';

export const URLS = {
  allFarmWithZones: 'farm/options/farms-with-zones',
};

export const getAllFarmWithZones = async (params = {}) => {
  const response = await axios.get(URLS.allFarmWithZones, { params });
  return response.data;
};
